module.exports = __webpack_public_path__ + "static/media/investor.6a53f785.svg";